<template>
    <div
        class="left-sidebar p-0"
        :class="(mobileView ? 'offcanvas offcanvas-start' : 'd-none d-sm-block') + (mini ? ' sidebar-mini ' : '') + ( ' bg-' + (G.isTheme(theme) ? `${theme} text-light` : 'light text-dark') ) + ( footerMenu !== undefined && footerMenu ? ' footer-menu' : '' )"
        id="offcanvasNavbar1"
        aria-labelledby="offcanvasWithBackdropLabel"
        :style="`width: ${width}px;`"
    >
        <div class="sidebarHeader text-primary" :class="mobileView ? 'd-block offcanvas-header' : ''">
            <div v-if="!mobileView" class="h-100 fw-bold d-flex flex-column justify-content-center align-items-center">
                <img :src="logo" class="rounded mb-2" title="..." />
                <div class="overflow-hidden text-center px-1 text-nowrap w-100 fs-6" :class="(mini ? 'd-none' : 'd-block my-21') + ( ' bg-' + (theme === 'light' || theme === 'none' ? 'light1 text-dark' : `${theme} text-light`) ) " v-html="title ? title : TR.sidebar_header"></div>
                <!-- <div class="h6 text-light fw-semibold overflow-hidden" :class="(mini ? 'd-none' : 'd-block')" v-html="G.projectTitle"></div> -->
            </div>

            <template v-else>
                <div class="offcanvas-title h-100 fw-bold d-flex flex-column justify-content-center align-items-center" id="offcanvasWithBackdropLabel">
                    <img :src="logo" class="rounded" title="..." />
                    <div
                        class="overflow-hidden text-center mt-21 px-1 text-nowrap w-100 fs-6"
                        :class="( ' bg-' + (theme === 'light' || theme === 'none' ? 'light1 text-dark' : `${theme} text-light`) ) "
                        v-html="title ? title : TR.sidebar_header"
                    ></div>
                    <!-- <div class="h6 text-light fw-semibold overflow-hidden" :class="(mini ? 'd-none' : 'd-block')" v-html="G.projectTitle"></div> -->
                </div>
                <button
                    type="button"
                    class="btn-close1 text-reset1"
                    :class="theme === 'light' || theme === 'none' ? 'text-dark' : `text-light`"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                ><i class="fas fa-times"></i></button>
            </template>
        </div>

        <div class="menu-content mb-auto scrollarea text-start" :class="mobileView ? 'offcanvas-body ' : ''" >
            <ul class="">
                <template v-for="(menu, index) in menus" :key="index">
                    <template v-if="menu.title != '-' && (menu.visible === undefined || menu.visible == true)">
                        <li class="mb-1" v-if="menu.items && menu.items.filter(item => G.getUserAccessToMenu(item.route_name)).length">
                            <a
                                class="sidebar-item sidebar-item-parent btn-toggle dropdown-item"
                                :class="( isActiveCollapse(menu.id) ? 'collapsed' : '' )"
                                :data-bs-toggle="mini ? 'dropdown' : 'collapse'"
                                :data-bs-target="`#sbm-${menu.id}-collapse`"
                                :aria-expanded="(isActiveCollapse(menu.id) ? false : true)"
                                :title="TR[menu.name] || menu.title || TR[menu.route_name] || ''"
                                @click="setActiveCollapse(menu.id, stored_menu[menu.id])"
                            >
                                <!-- :aria-expanded="(isActiveCollapse(menu.id) ? true : (menu.collapsed !== undefined && menu.collapsed == true ? true : false))" -->
                                <i class="p-1" :class="menu.icon" :title="TR[menu.name] || menu.title || TR[menu.route_name] || ''"></i>
                                <!-- <span class="fw-bold">{{ menu.title }}</span> -->
                                <span class="fw-bold">{{ TR[menu.name] || menu.title || TR[menu.route_name] || '' }}</span>
                            </a>
                            <ul
                                class="fw-normal p-11"
                                :class="(mini ? 'dropdown-menu' : ( 'collapse ' + (isActiveCollapse(menu.id) ? '' : 'show') )) + ( ' bg-' + (G.isTheme(theme) ? `${theme} text-light` : 'light text-dark') )"
                                :id="`sbm-${menu.id}-collapse`"
                            >
                                <!-- :class="(mini ? 'dropdown-menu' : ( 'collapse ' + (isActiveCollapse(menu.id) ? 'show' : ( menu.collapsed !== undefined && menu.collapsed == true ? 'show' : '' )) )) + ( ' bg-' + (G.isTheme(theme) ? `${theme} text-light` : 'light text-dark') )" -->

                                <template v-for="(item, key) in menu.items" :key="key">
                                    <li v-if="item.title == '-'">
                                        <hr class="dropdown-divider" />
                                    </li>
                                    <li v-else-if="!G.disabled_routes.includes(item.route_name) && G.getUserAccessToMenu(item.route_name)"
                                    class=""
                                    >
                                            <!-- :class="$route.name == item.route_name ? 'active' : ($route.name == 'index' && item.route_name == defaultSelectedMenu ? 'active' : '') " -->
                                        <a
                                            class="dropdown-item sidebar-item-dropdown"
                                            :class="item.route_name == $route.name || ($route.name == 'index' && item.route_name == defaultSelectedMenu) || ($route.meta.selected_menu && $route.meta.selected_menu == item.route_name) ? 'active' : ''"
                                            :title="TR[item.name] || item.title || TR[item.route_name] || ''"
                                            @click="setComponent(typeof item.route_name !== undefined || item.route_name != '' ? item.route_name : '', routesObj[item.route_name] != undefined ? routesObj[item.route_name].props.data.data : {} )"
                                        >
                                            <!-- :href="item.link" -->
                                            <i v-if="item.icon" class="p-1" :class="item.icon" :title="TR[item.name] || item.title || TR[item.route_name] || ''"></i>
                                            <i v-else class="pb-1 text-center fw-bold line-icon">&#9866;</i>
                                            <!-- <span>{{item.title}}</span> -->
                                            <!-- <span>{{ TR[item.name] || TR[item.route_name] }}</span> -->
                                            <span>{{ TR[item.name] || item.title || TR[item.route_name] || '' }}</span>
                                        </a>
                                    </li>
                                </template>
                            </ul>
                            <!-- <div class="collapse show" id="home-collapse1" style></div> -->
                        </li>
                        <li v-else-if="menu.title == '-'">
                            <hr class="dropdown-divider" />
                        </li>
                        <li v-else-if="!menu.items && !G.disabled_routes.includes(menu.route_name) && G.getUserAccessToMenu(menu.route_name)" class="">
                            <a
                                class="dropdown-item" :class="menu.route_name == $route.name || ($route.name == 'index' && menu.route_name == defaultSelectedMenu) || ($route.meta.selected_menu && $route.meta.selected_menu == menu.route_name) ? 'active' : ''"
                                @click="setComponent(menu.route_name, routesObj[menu.route_name] != undefined ? routesObj[menu.route_name].props.data.data : {})"
                                :title="TR[menu.name] || menu.title || TR[menu.route_name] || ''"
                            >
                            <!-- @click="setComponent(menu.route_name, routesObj.filter(e => menu.route_name == e.name).length ? routesObj.filter(e => menu.route_name == e.name)[0].props.data.data : {})" -->
                            <!-- :href="menu.link" -->
                                <i class="p-1" :class="menu.icon" :title="TR[menu.name] || menu.title || TR[menu.route_name] || ''"></i>
                                <!-- <span>{{menu.title}}</span> -->
                                <span>{{ TR[menu.name] || menu.title || TR[menu.route_name] || '' }}</span>
                            </a>
                        </li>
                    </template>
                    <!-- <li v-else-if="menu.title == '-' && (menu.role == 'user' || G.token_data()['role'] == 'admin')"> -->
                    <li v-else-if="menu.title == '-' && (menu.role == 'user' || !G.privateIfNotAdmin())">
                        <hr class="dropdown-divider" />
                    </li>
                </template>
            </ul>
        </div>
        <div v-if="footerMenu !== undefined && footerMenu && (!mini && !mobileView)" class="d-inline-flex align-items-center justify-content-center w-100 border-top border-opacity-25 bg-secondary bg-opacity-25 border-light py-2 px-2 text-light fs-7" v-html="footerMenuText"></div>
        <div v-else-if="footerMenu !== undefined && footerMenu && (mini && !mobileView)" class="d-inline-flex align-items-center justify-content-center w-100 border-top border-opacity-25 bg-secondary bg-opacity-25 border-light py-2 px-2 text-light fs-7 fw-bold" v-html="footerMenuMiniText"></div>
        <div v-else-if="footerMenu !== undefined && footerMenu && (!mini && mobileView)" class="d-inline-flex align-items-center justify-content-center w-100 border-top border-opacity-25 bg-secondary bg-opacity-25 border-light py-2 px-2 text-light fs-7 fw-bold" v-html="footerMenuText"></div>
    </div>
</template>


<script>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";

    import { G } from "@/_common";

    import { routesObj } from "@/system_modules/router";

    // import SVGLogo from '@/components/SVGLogo';

    export default {
        name: "SidebarMenuC",
        props: {
            title: String,
            logo: {
                type: String,
                default: ''
            },
            theme: {
                type: String,
                default: 'light'
            },
            width: {
                type: Number,
                default: 280,
                // validator(value) {
                //     return value >= 0 ? true : false;
                // }
            },
            setComponent: {
                type: Function,
                default(){
                    return null;
                }
            },
            defaultSelectedMenu: {
                type: String,
                default: G.defaultSelectedMenu
            },
            menus: {
                type: Array,
                default(){
                    return [];
                }
            },
            footerMenu: {
                type: Boolean,
                default: false
            },
            footerMenuText: {
                type: String,
                default: ''
            },
            footerMenuMiniText: {
                type: String,
                default: ''
            }
        },
        components:{
            // SVGLogo,
        },

        setup(props) {
            const store = useStore();

            const showSidebar = ref(true);

            const mini = ref(false);

            // const mobileView = ref(true);
            const mobileView = ref(G.is_mobile());
            const TR = ref({});

            const stored_menu = ref(JSON.parse(G.getClientData("activeCollapse")));

            onMounted(() => {
                // mini.value = mobileView.value
                //     ? false
                //     : store.getSidebarStatus();
                // await ajax
                //   .get(`menu/`, {
                //     headers: {
                //       Authorization: `${G.token}`,
                //     },
                //   })
                //   // ;
                //   // const postResult = fortmatResponse(result);
                //   .then((e) => {
                //     if (e.data) {
                //       menus.value = e.data;
                //       menus.value.forEach((e, i)=>{
                //         if( e.page === G.current.value.page )
                //           activeItem.value = i;
                //       });
                //     }
                //   })
                //   .catch((error) => {
                //     G.removeClientData("DA_AUTH_TOKEN");
                //   });

                if( !G.hasClientData("activeCollapse")){
                    G.setClientData("activeCollapse", JSON.stringify({}));
                }
                if( Object.keys(JSON.parse(G.getClientData("activeCollapse"))).length == 0 ){
                    let st = {};
                    props.menus.forEach(menu => {
                        if( menu.collapsed !== undefined && menu.collapsed == true ){
                            st[menu.id] = true;
                        }
                        else{
                            st[menu.id] = false;
                        }
                    });
                    G.setClientData("activeCollapse", JSON.stringify(st));
                    stored_menu.value = st; //JSON.parse(G.getClientData("activeCollapse"));
                }
            });

            watchEffect(() => {
                TR.value = store.getTranslation();
                mobileView.value = G.is_mobile();
                mini.value = mobileView.value
                    ? false
                    : store.getSidebarStatus();
            });

            const isActiveCollapse = (idn) => {
                return stored_menu.value[idn] !== undefined && stored_menu.value[idn] == true ? true : false;
            };

            const setActiveCollapse = (idn, val) => {
                if( !mini.value ){
                    // let stored_menu = JSON.parse(G.getClientData("activeCollapse"));
                    // if( stored_menu.value instanceof Object === false ){
                    //     stored_menu.value = {[stored_menu.value]: !val};
                    // }
                    // if( stored_menu.value[idn] === undefined ){
                    //     }
                        stored_menu.value[idn] = !val;
                    // else{
                    //     // delete stored_menu.value[idn];
                    // }
                    G.setClientData("activeCollapse", JSON.stringify(stored_menu.value));
                }
            };

            // // const selectMenu = (route_name, activeIndex) => {
            // const selectMenu = (route_name) => {
            //     // props.selectMenuItem(activeIndex);
            //     if (typeof route_name !== undefined || route_name != "")
            //         props.setComponent(route_name);
            // };

            return {
                TR,
                G,
                // menus,
                mini,
                mobileView,
                setActiveCollapse,
                isActiveCollapse,
                // selectMenu,
                showSidebar,
                routesObj,
                stored_menu,
            };
        },
    };
</script>


<style lang="scss" scoped>
    .scrollarea {
        overflow-y: auto;
        overflow-x: hidden;
    }
    .offcanvas-body {
        padding: 0px;
    }
    ul {
        list-style: none;
        padding-left: 0;
    }
    .left-sidebar {
        // width: 280px;
        height: calc( 100vh - 0px );
        max-height: calc( 100vh - 0px );

        overflow-y: auto;
        -webkit-transition: 0.1s ease-out;
        -moz-transition: 0.1s ease-out;
        -o-transition: 0.1s ease-out;
        transition: all 0.1s ease-out;
    }
    // .main-content {
    //     -webkit-transition: 0.1s ease-out;
    //     -moz-transition: 0.1s ease-out;
    //     -o-transition: 0.1s ease-out;
    // }
    .offcanvas-header .btn-close1 {
        position: absolute;
        top: 10px;
        right: 0px;
        // padding: 15px;
        background: unset;
        border: 0px;
    }

    .sidebarHeader {
        // background: linear-gradient(70deg, rgb(243, 241, 241), rgb(2, 85, 85)) !important;
        color: #ffffff;
        img {
            width: 6rem;
            height: 5rem;
            object-fit: contain;
            background: linear-gradient(0deg, rgb(255, 255, 255), transparent);
            padding: .2rem;
        }
        height: 160px;
        font-size: 1rem;
        // border-bottom: 1px solid rgba(226, 226, 226, .3);
    }
    .menu-content {
        height: calc(100vh - 165px);
        max-height: calc(100vh - 165px);
    }
    .footer-menu .menu-content {
        height: calc(100vh - 195px);
        max-height: calc(100vh - 195px);
    }

    .dropdown-divider{
        background-color: rgba(205, 205, 205, 0.2);
    }

    .sidebar-mini .sidebarHeader {
        img {
            width: 2rem !important;
            height: 2rem;
        }
        height: 68px;
        // height: 51px;
    }
    .sidebar-mini .menu-content {
        // max-height: calc(100vh - 65px);
        max-height: calc(100vh - 55px);
    }
    .sidebar-mini.footer-menu .menu-content {
        height: calc(100vh - 103px);
        max-height: calc(100vh - 103px);
    }

    .left-sidebar i {
        color: var(--main-rgb);
        // width: 32px;
        width: 25px;
        // width: 24px;
        text-align: start;
        margin-right: 10px;
    }
    .sidebar-item-dropdown {
        cursor: pointer;
        align-items: center !important;
        display: flex !important;
    }
    .sidebar-item-parent{
        background-color: rgba(200, 200, 200, .2);
    }
    .sidebar-item-parent::after{
        color: #fff;
    }
    .left-sidebar .scrollarea > ul > li {
        padding: 0rem;
        margin: 0 6px;
    }
    .left-sidebar li {
        padding: 0rem;
    }
    .left-sidebar li a {
        padding: .6rem;
        cursor: pointer;
    }
    .left-sidebar li a:hover {
        background-color: var(--bs-gray-200);
    }
    .left-sidebar li a:hover i, .left-sidebar li a:hover span{
        background-color: unset;
    }
    .left-sidebar .sidebar-item-dropdown {
        // padding-left: 25px;
        padding-left: 1rem;
    }
    .dropdown-item.sidebar-item-dropdown{
        // padding-left: 2.5rem;
        padding-left: 1.0rem;
    }
    .dropdown-item.sidebar-item-dropdown i{
        width: 25px;
        margin-right: 5px;
    }
    // .dropdown-item.sidebar-item-dropdown i.line-icon{
    //     width: 20px;
    //     margin-right: 5px;
    // }
    .left-sidebar.sidebar-mini .dropdown-item{
        padding-left: 1rem;
    }



    /** Dropdown Parent menu item */
    .btn-toggle {
        display: inline-flex;
        align-items: center;
        padding: 0.4rem 0.4rem;
        width: 100%;
    }
    .btn-toggle::after {
        width: 0.9em;
        line-height: 0;
        margin-left: auto;
        content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 16 16' %3e%3cpath fill='none' stroke='rgba%280,0,0,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
    }

    a.btn-toggle::after {
        transform: rotate(90deg);
    }
    a.btn-toggle.collapsed::after {
        transform: rotate(0deg);
    }
    /** Dropdown Parent menu item */



    /** Sidebar mini menu open on the right */
    .left-sidebar.sidebar-mini {
        width: 70px !important;
        -webkit-transition: 0.1s ease-out;
        -moz-transition: 0.1s ease-out;
        -o-transition: 0.1s ease-out;
        transition: all 0.1s ease-out;
    }
    .left-sidebar.sidebar-mini li > a > i {
        margin-right: 0px;
        padding-right: 0px;
        // text-align: center;
        font-size: 1.2rem;
    }
    .left-sidebar.sidebar-mini li > ul li i{
        margin-right: 4px;
        font-size: unset;
    }
    .left-sidebar.sidebar-mini li > ul li a{
        padding: .5rem;
    }
    .left-sidebar .dropdown-item{
        white-space: unset;
    }
    .left-sidebar .dropdown-item span {
        width: fit-content;
    }

    .sidebar-mini .dropdown-item span,
    .sidebar-mini .sidebar-item span {
        display: none;
    }
    .sidebar-mini ul ul .dropdown-item span {
        display: block;
    }
    .left-sidebar.sidebar-mini li a {
        padding: .8rem;
        // padding: 0.5rem;
        cursor: pointer;
    }
    .left-sidebar li li .dropdown-item{
        background: rgba(var(--bs-secondary-rgb), .2);
        // background-color: #c91313 !important;
    }
    .left-sidebar .dropdown-item.active{
        color: #000000;
        background-color: var(--bs-gray-400);
    }
    .left-sidebar .dropdown-item.active i, .dropdown-item.active span{
        background-color: unset;
    }
    .sidebar-mini .dropdown-menu {
        left: 64px !important;
        margin-top: -55px !important;
        // margin-top: -36px !important;
        font-size: inherit;
        border-radius: 0;
        padding: 0px;
        min-width: 250px;
        max-height: 402px;
        overflow-y: auto;
    }
    .sidebar-mini .dropdown-item{
        padding: .8rem;
        // padding: 0.5rem;
    }
    .sidebar-mini div > ul > li > .dropdown-item{
        justify-content: center;
        display: flex;
    }
    .sidebar-mini .btn-toggle::before {
        content: "";
    }
    .sidebar-mini .btn-toggle::after {
        // margin: 4px 0px 0px 3px;
        content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 16 16' %3e%3cpath fill='none' stroke='rgba%280,0,0,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
    }
    .sidebar-mini a.btn-toggle::after {
        transform: rotate(0deg);
        margin-left: 6px;
    }
    .sidebar-mini .dropdown-divider{
        background-color: rgba(205, 205, 205, 0.5);
    }
    /** Sidebar mini menu open on the right */


    .bg-none{
        // .dropdown-menu, .sidebar-item-dropdown,
        .offcanvas, .offcanvas-body, .offcanvas-header,
        .dropdown-item
        {
            background-color: var(--bs-gray-200);
        }
        .sidebar-item-parent{
            background-color: var(--bs-gray-300);
        }
        .sidebar-item-parent, .dropdown-item{
            color: #000000;
        }
        .sidebar-item:hover, .dropdown-item:hover {
            background-color: var(--bs-gray-400) !important;
            color: #000000;
        }
        .left-sidebar .dropdown-item.active{
            color: #000000;
            background-color: var(--bs-gray-500);
        }
        .left-sidebar .dropdown-item.active i, .left-sidebar .dropdown-item.active span{
            color: #000000 !important;
            background-color: unset;
        }
    }

    .bg-light{
        .sidebar-item-parent, .dropdown-item{
            color: #000000;
        }
        .sidebar-item:hover, .dropdown-item:hover {
            background-color: var(--bs-gray-400);
            color: #000000;
        }
    }

    .bg-custom,
    .bg-dark,
    .bg-primary,
    .bg-secondary,
    .bg-warning,
    .bg-danger,
    .bg-success,
    .bg-info{
        .sidebar-item-parent{
            background-color: rgba(226, 226, 226, 0.1);
            color: #fff;
        }
        .sidebar-item-dropdown{
            color: #fff;
        }
        .btn-toggle::after {
            width: 0.9em;
            line-height: 0;
            margin-left: auto;

            content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 16 16' %3e%3cpath fill='none' stroke='rgba%28255,255,255,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
        }
        .sidebar-mini .btn-toggle::after {
            margin: 4px 0px 0px 3px;
            content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 16 16' %3e%3cpath fill='none' stroke='rgba%28255,255,255,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
        }
        &.left-sidebar i {
            color: var(--bs-white);
        }
        .sidebar-item:hover, .dropdown-item:hover, .dropdown-item:hover i {
            background-color: var(--bs-gray-400);
            color: #000000;
        }
        .sidebar-item:hover::after
        {
            content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 16 16' %3e%3cpath fill='none' stroke='rgba%280,0,0,1%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
        }
        .left-sidebar .dropdown-item.active{
            color: #ffffff;
            background-color: var(--bs-gray-500);
        }
        .left-sidebar .dropdown-item.active i, .left-sidebar .dropdown-item.active span{
            color: #ffffff !important;
            background-color: unset;
        }
    }


    @media (max-width: 576px){
        .left-sidebar{
            padding: 0.2rem;
            height: 100vh;
            max-height: 100vh;
        }
        .menu-content {
            height: calc(100vh - 14px);
            max-height: calc(100vh - 14px);
        }
        .dropdown-item{
            padding: 0.25rem 0.6rem;
        }
    }

</style>
